<template>
  <li class="px-xs sm:px-twentyFive py-xs">
    <button
      @click="$emit('toggled', id, title)"
      class="py-sm px-sm flex gap-twentyFive items-center rounded-xl w-full border-none cursor-pointer"
      :class="
        selected
          ? 'bg-signableBrandColours-signableBlue text-signableBrandColours-white'
          : 'hover:bg-signableBrandColours-highlightGrey text-signableBrandColours-black bg-transparent'
      "
      data-test="content"
      role="checkbox"
      :aria-label="title"
      :aria-checked="selected"
    >
      <div
        class="flex"
        data-test="checkbox"
      >
        <VCheckbox
          type="checkbox"
          :checked="selected"
          @input="$emit('toggled', id, title)"
          :data-ec="ec"
          :data-et="`select_${itemType}_checkbox`"
          tabindex="-1"
        />
      </div>
      <div class="flex flex-col sm:flex-row items-start sm:items-center flex-grow gap-xs sm:gap-twentyFive justify-between min-w-0">
        <span
          class="text-14 w-full text-left line-clamp-2 break-all"
          :title="title"
          data-test="title"
        >
          {{ title }}
        </span>
        <span
          v-if="secondaryInfo"
          class="flex-shrink-0 text-12 text-midGray truncate w-full text-left sm:max-w-listItemSecondaryInfo sm:text-right"
          :class="{ '!text-signableBrandColours-white': selected }"
          data-test="secondary-info"
        >
          {{ secondaryInfo }}
        </span>
      </div>
    </button>
  </li>
</template>

<script>
import { defineComponent } from 'vue';

import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';

export default defineComponent({
  components: { VCheckbox },
  props: {
    selected: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    secondaryInfo: String,
    id: {
      type: String,
      required: true,
    },
    ec: String,
    itemType: {
      type: String,
      default: 'item',
    },
  },
});
</script>
